import { Button } from '@slal/ui/buttons';
import { Modal, ModalBody, ModalFooter } from '@slal/ui/modal';
import { Article, Li, P, Ul } from '@slal/ui/typography';
import { useCallback, useState } from 'react';
import { LinkButton } from '~/components';

export const IncomeTax = () => {
    const [isModalopen, setIsModalOpen] = useState(false);
    const closeModal = useCallback(() => setIsModalOpen(false), [setIsModalOpen]);
    const openModal = useCallback(() => setIsModalOpen(true), [setIsModalOpen]);

    return (
        <>
            <Article>
                <P>
                    You'll normally pay income tax on your pension income.{' '}
                    <LinkButton onClick={openModal}>Learn more</LinkButton>
                </P>
            </Article>
            <Modal isOpen={isModalopen} onClose={closeModal} title="Things to think about">
                <ModalBody>
                    <Article>
                        <P>
                            Income from your pension is usually taxed at your income tax rate. This depends on your
                            total income in the tax year, including pension income, so check if this could push you into
                            a higher tax bracket.
                        </P>
                        <P markdown>
                            We'll normally use your tax-free cash first to provide the payments you've asked for. Once
                            your tax-free cash is used up, the payments you receive will be taxable. If you prefer, you
                            can spread any remaining tax-free cash over future income instead - [call
                            us](https://www.standardlife.co.uk/help) for more details.
                        </P>
                        <P>
                            Once your payments become taxable, the maximum that you or an employer can pay into any of
                            your defined contributions pensions, without attracting a tax charge, normally reduces to
                            £10,000 a year with no carry forward. This can be a problem if you are still earning and:
                        </P>
                        <Ul>
                            <Li>have other savings you want to pay into your pension for a tax uplift, or</Li>
                            <Li>significant pension contributions are likely in the future</Li>
                        </Ul>
                        <P>
                            Check this allowance isn't going to be a problem before going ahead. Once the allowance
                            reduces you can't change your mind later.
                        </P>
                        <P>
                            If your pension has a value of £10,000 or less, you may be able to avoid this reduction if
                            you cash in the pension fully using the 'small pots' rules.
                        </P>
                    </Article>
                </ModalBody>
                <ModalFooter>
                    <Button variant="solid" color="secondary" onClick={closeModal}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};
